import "@patternfly/patternfly/patternfly-addons.css";
import "@patternfly/react-core/dist/styles/base.css";

import { KeycloakProvider } from "@keycloak/keycloak-account-ui";
import { environment } from "./environment";

import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { i18n } from "./i18n";
import { routes } from "./routes";

import { ContentAlertProvider } from "./ContentAlert";

const router = createBrowserRouter(routes);

// デフォルトテーマである dark を強制的に light に変更
const html = document.documentElement;
html.classList.remove("pf-v5-theme-dark");
html.classList.add("pf-v5-theme-light");

i18n.init().then(() => {
  ReactDOM.createRoot(document.getElementById("app")!).render(
    <React.StrictMode>
      <KeycloakProvider environment={environment}>
        <ContentAlertProvider>
          <RouterProvider router={router} />
        </ContentAlertProvider>
      </KeycloakProvider>
    </React.StrictMode>
  );
});